'use client';

import { Nationwide } from '@ahamove/icons/pages';
import { DeliveryType, type Service } from '@ahm/api-wrappers-core';
import { generateLetterAvatar } from '@ahm/common-helpers';
import {
  Avatar,
  Button,
  Center,
  CloseButton,
  ScrollArea,
  SimpleGrid,
  Text,
  Title,
  em,
  rem,
} from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { closeAllModals, type ContextModalProps } from '@mantine/modals';
import { useTranslations } from 'next-intl';
import { Fragment } from 'react';
import { useLocaleSuffix } from '@/navigation';
import { useBookingStore } from '@/stores/booking/booking-store-provider';

export type ServiceDetailsModalProps = {
  service: Service;
  onChangeService?: (s: Service) => void;
};

const ServiceDetailsModal = ({
  innerProps,
}: ContextModalProps<ServiceDetailsModalProps>) => {
  const { service, onChangeService } = innerProps;
  const localeSuffix = useLocaleSuffix();
  const tCommon = useTranslations('common');
  const isMobile = useMediaQuery(`(max-width: ${em(767)})`);

  const { selectedService } = useBookingStore((state) => state);

  const isSelected = service?._id === selectedService?._id;

  const handleSelectService = (data: Service) => {
    onChangeService?.(data);
  };

  const handleClose = () => {
    closeAllModals();
  };
  return (
    <Fragment>
      <CloseButton
        pos="absolute"
        iconSize={rem(24)}
        variant="transparent"
        onClick={handleClose}
        c="neutral.6"
        top={rem(16)}
        style={
          isMobile
            ? {
                left: rem(16),
                outline: 'none',
              }
            : {
                right: rem(16),
                outline: 'none',
              }
        }
      />
      <Center mb={rem(24)}>
        <Avatar
          radius="md"
          variant="outline"
          size={rem(130)}
          flex="none"
          src={service?.icon_url}
          alt={service?.[`name_${localeSuffix}`]}
          styles={{
            placeholder: {
              border: 'none',
            },
          }}
        >
          {selectedService?.delivery_type === DeliveryType.Nationwide ? (
            <Nationwide width={148} height={148} />
          ) : (
            generateLetterAvatar(service?.[`name_${localeSuffix}`])
          )}
        </Avatar>
      </Center>
      <Title mb={rem(8)} ta="center" order={3} c="neutral.7">
        {service[`name_${localeSuffix}`]}
      </Title>
      <ScrollArea.Autosize mb={rem(16)}>
        <Text
          px={{ base: rem(16), sm: rem(24) }}
          size="sm"
          fw={500}
          c="neutral.6"
          component="div"
          styles={{
            root: {
              whiteSpace: 'pre-line',
            },
          }}
          dangerouslySetInnerHTML={{
            __html: service[`fee_description_${localeSuffix}`] ?? '',
          }}
        />
      </ScrollArea.Autosize>
      <SimpleGrid w="100%" cols={1} spacing="md">
        <Button
          fullWidth
          variant="light"
          color="neutral.7"
          mih={rem(48)}
          radius={rem(4)}
          fw={700}
          onClick={handleClose}
          size="sm"
          styles={{
            label: {
              color: 'var(--mantine-color-neutral-7)',
            },
          }}
        >
          {tCommon('got_it')}
        </Button>
        {/* {!isSelected ? (
          <Button
            fullWidth
            mih={rem(48)}
            radius={rem(4)}
            fw={700}
            onClick={() => {
              handleSelectService(service);
              handleClose();
            }}
          >
            Chọn dịch vụ
          </Button>
        ) : null} */}
      </SimpleGrid>
    </Fragment>
  );
};
//

export default ServiceDetailsModal;
